// extracted by mini-css-extract-plugin
module.exports = {"landing_page_G":"G_landing_page_G__JrtPK"};